<template>
    <div>
        <loading 
            :active.sync="isLoading" 
            :opacity="0.8"
            color="#f5365c"
            :is-full-page="true">
        </loading>
        <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/estaciones"
                            class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
                <i class="ni ni-bold-left pr-3"></i>Regresar
            </router-link>
        </base-header>
        
        <div v-if="step === 1" class="container-fluid mt--7 pb-8">
            <div class="row">
                <div class="col">
                    <clients-picker-table title="Búsqueda de cliente" :tableData="tableData" @client-selected="hasSelectedClient" @next-step="nextStep"></clients-picker-table>
                </div>
            </div>
        </div>
        <div v-if="step === 2" class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
                    <div class="card card-profile shadow">
                        <div class="card-body pt-0 pt-sm-4">
                            <div class="text-center">
                                <h3>
                                    {{stationData.razonSocial}}
                                </h3>
                            </div>
                            <hr class="my-4" />
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">{{clientData.clientId}}</span>
                                            <span class="description">ID de Cliente</span>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <small>{{clientData.createdOn ? `Agregado el ${getReadableDate(clientData.createdOn)} por ${clientData.createdBy}` : ''}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h3 class="mb-0">Estación de Servicio</h3>
                                    <h5 class="mb-0 text-muted">{{stationData.numCRE}}</h5>
                                </div>
                                <div class="col-6 text-right">
                                    <button v-if="!canSave" disabled class="btn btn-default">Guardar</button>
                                    <button v-else class="btn btn-default" @click="onSave">Guardar</button>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Permiso CRE *</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <base-input alternative="Permiso CRE"
                                                        placeholder="Permiso CRE"
                                                        :required="true"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.numCRE"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <h6 class="heading-small text-muted mb-4">Datos de contacto</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Contacto"
                                                        placeholder="Contacto"
                                                        :required="true"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.contacto"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Tipo contacto"
                                                        placeholder="Tipo contacto"
                                                        :required="true"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.tipoContacto"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Teléfono"
                                                        :required="true"
                                                        placeholder="Teléfono"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.telefono"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Teléfono 2"
                                                        placeholder="Teléfono 2"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.movil"
                                            />
                                        </div>
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="Correo Electrónico"
                                                        placeholder="Correo Electrónico"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.email"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative="Testigo"
                                                        label="Testigo"
                                                        placeholder="Testigo"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.testigo"/>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative="Representante Legal"
                                                        label="Representante Legal"
                                                        placeholder="Representante Legal"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.repLegal"/>
                                        </div>
                                        <div class="col-lg-12">
                                            <base-input alternative="Responsable SASISOPA"
                                                        label="Responsable SASISOPA"
                                                        placeholder="Responsable SASISOPA"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.repSasisopa"/>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Ubicación</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Dirección"
                                                        placeholder="Dirección"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.domicilio"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Ciudad"
                                                        :required="true"
                                                        placeholder="Ciudad"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.ciudad"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Estado"
                                                        :required="true"
                                                        placeholder="Estado"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.estado"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Código Postal"
                                                        :required="true"
                                                        placeholder="Código Postal"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.cp"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Notas -->
                                <h6 class="heading-small text-muted mb-4">Notas</h6>
                                <div class="pl-lg-4">
                                    <div class="form-group">
                                        <base-input alternative="">
                                            <textarea rows="10" v-model="stationData.notas" class="form-control form-control-alternative" placeholder="Notas y comentarios acerca del cliente"></textarea>
                                        </base-input>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import ClientsPickerTable from './Tables/ClientsPickerTable';
    import moment from "moment";
    import router from '../router';
    export default {
        name: 'user-profile',
        components: {
            Loading,
            ClientsPickerTable
        },
        created(){
            const token = localStorage.getItem('id_token');
            this.isLoading = true;
            fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients`, {
                method: 'GET',
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }).then(response => response.json())
                .then((data) => {
                    this.tableData = data.Data.Items;
                    this.isLoading = false;
                })
                .catch(() => {
                    console.error('error');
                });
        },
        computed: {
            canSave(){
                let requiredFields = ['numCRE', 'contacto', 'tipoContacto', 'telefono', 'ciudad',' estado', 'cp'];
                let values = [];
                let val = ''
                for (let attribute in this.stationData) {
                    if (requiredFields.includes(attribute)) {
                        val = this.stationData[attribute];
                        values.push(val);
                    }
                }
                return values.every( value => {
                    return value && !this.isEmptyOrSpaces(value);
                });
            }
        },
        methods: {
            isEmptyOrSpaces(str){
                return str === null || str.match(/^\s*$/) !== null;
            },
            getReadableDate(timestamp){
                moment.locale('es');
                let time = moment(timestamp, 'x');
                return time.format('LL');
            },
            hasSelectedClient(row){
                this.stationData.clientId = row.clientId;
                this.stationData.razonSocial = row.razonSocial;
                this.clientData.clientId = row.clientId;
                this.clientData.createdOn = row.createdOn;
                this.clientData.createdBy = row.createdBy;
                this.step = 2;
            },
            onSave(){
                const token = localStorage.getItem('id_token');
                this.isLoading = true;
                fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients/${this.clientId}/stations`, {
                    method: 'POST', 
                    body: JSON.stringify(this.stationData),
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => response.json()).catch(err => console.log(err))
                .then((data) => {
                    let estacionId = data.Data.estacionId;
                    this.isLoading = false;
                    router.replace({ path: `profile/${this.stationData.clientId}/${estacionId}`});
                })
            },
            nextStep(clientData){
                this.clientData = clientData;
                this.stationData.clientId = clientData.clientId;
                this.stationData.razonSocial = clientData.razonSocial;
                this.step = 2;
            }
        },
        data() {
            return {
                selected: null,
                step: 1,
                editMode: false,
                isLoading: false,
                clientId: '',
                tableData: [],
                stationData: {
                    ciudad: undefined,
                    clientId: undefined,
                    contacto: undefined,
                    cp: undefined,
                    email: undefined,
                    estacionId: undefined,
                    estado: undefined,
                    movil: undefined,
                    numCRE: undefined,
                    razonSocial: undefined,
                    telefono:undefined,
                    tipoContacto: undefined,
                    notas: undefined,
                    repLegal: undefined,
                    repSasisopa: undefined,
                    testigo: undefined,
                    domicilio: undefined,
                    archivos: []
                },
                clientData: {}
            }
        },
    };
</script>
<style></style>
